<s1-modal #modal [title]="'cardsModal.title'"> 
  <leu-customer-cards-section [customer]="customer"></leu-customer-cards-section>
</s1-modal>